<script lang="jsx">
  import { defineComponent, ref, watch, computed } from 'vue';
  import _ from 'lodash-es';
  import SortIcon from '@/components/SortIcon.vue';
  import EmptyDataCard from '@/components/EmptyDataCard.vue';
  import { SORT_ORDER } from '@/config/tableConfig.js';
  import { showConfirmDialog } from 'vant';
  import dayjs from "dayjs"

  export default defineComponent({
    emits: ['tdClick'],
    props: {
      /**
       * @param title 标题
       * @param unit 单位
       * @param dataIndex 索引
       * @param width 宽度
       * @param sortable 是否开启排序
       * @param onSort 排序点击的回调
       */
      columns: {
        type: Array,
        require: true,
      },
      data: {
        type: Array,
        default: () => [],
      },
    },
    setup(props, { emit }) {
      const columnsState = ref(props.columns);
      const dataState = ref(props.data);
      const showAll = ref(false);
      const MAX_ROWS = 10;
      const visibleData = computed(() => {
        if (showAll.value) return dataState.value;
        return dataState.value.slice(0, MAX_ROWS);
      });

      function handleSort(col, index) {
        switch (col.sortOrder) {
          case 'asc':
            col.sortOrder = SORT_ORDER.DESC;
            break;
          case 'desc':
            col.sortOrder = SORT_ORDER.ALL;
            break;
          case 'all':
            col.sortOrder = SORT_ORDER.ASC;
            break;
          default:
            col.sortOrder = SORT_ORDER.ALL;
            break;
        }

        columnsState.value.forEach((item) => {
          if (item.sortable && col.dataIndex !== item.dataIndex) {
            item.sortOrder = SORT_ORDER.ALL;
          }
        });
        emit('sort', col.sortOrder, index, col);
      }

      function toggleShowAll() {
        showAll.value = !showAll.value;
      }

      watch(
        () => props.columns,
        (newValue, oldValue) => {
          if (!_.isEqual(newValue, oldValue)) {
            columnsState.value = newValue;
          }
        },
        {
          deep: true,
        },
      );

      watch(
        () => props.data,
        (newValue, oldValue) => {
          if (!_.isEqual(newValue, oldValue)) {
            dataState.value = newValue;
          }
        },
        {
          deep: true,
        },
      );

      if (dataState.value.length <= 0) {
        return () => <EmptyDataCard />;
      }

      return () => (
        <div>
          <table className="sort-table">
            <thead className="thead">
              {columnsState.value.map((col, index) => {
                const startBool = col?.start;
                const endBool = col?.end;

                if (col.sortable) {
                  const { sortOrder } = col;

                  return (
                    <th
                      {...col}
                      className={'th th-sortable' + sortOrder}
                      onClick={() => handleSort(col, index)}>
                      <div className="header-title">
                        <span className="th-title">{col.title}</span>
                        {col.unit && <span className="title">{col.unit}</span>}
                      </div>
                      <SortIcon sortOrder={sortOrder} />
                    </th>
                  );
                }
                return (
                  <th
                    {...col}
                    style={{textAlign: startBool ? 'left' : endBool ? 'right' : 'center'}}
                    className="th">
                    <div className="header-title">
                      <span className="th-title">{col.title}</span>
                      {col.unit && <span className="title">{col.unit}</span>}
                    </div>
                  </th>
                );
              })}
            </thead>
            <tbody className="tbody">
              {visibleData.value.map((rowData) => {
                return (
                  <tr className="tr">
                    {columnsState.value.map((column) => {
                      const fieldId = column.dataIndex;
                      const desNum = column?.des;
                      const tagBool = column?.tag;
                      const startBool = column?.start;
                      const endBool = column?.end;
                      const cellValue = rowData[fieldId] ?? '--';
                      console.log('rowData>>>>',rowData)
                      const desValue = rowData[desNum];
                      const tagValue = rowData['tagValue'];
                      const isPupBool = column?.isPup;
                      const titleValue = column?.title
                      const isAddProduct = column?.isAddProduct;
                      const isRefundProduct = column?.isRefundProduct;

                      let isAddDes = null

                      if(isAddProduct) {
                        isAddDes = `签约时段：${dayjs(rowData.startTime).format('YYYY-MM-DD')}~${dayjs(rowData.endTime).format('YYYY-MM-DD')}`
                        if(rowData?.signActiveName) {
                          isAddDes = `${isAddDes}\n活动标签：${rowData?.signActiveName}`
                        }

                        if (rowData?.limitNumber) {
                          isAddDes = `${isAddDes}\n限制次数：${rowData?.limitNumber}`
                        }

                        if (rowData?.signNotes) {
                          isAddDes = `${isAddDes}\n备注：${rowData?.signNotes}`
                        }

                        
                      }

                      let isRefundDes = null
                      if(isRefundProduct) {
                        isRefundDes = `退款原因：${rowData?.refundReason}`
                        if(rowData?.refundTime) {
                          isRefundDes = `${isRefundDes}\n退款时间：${dayjs(rowData.refundTime).format('YYYY-MM-DD')}`
                        }
                        if(rowData?.refundTypeDesc) {
                          isRefundDes = `${isRefundDes}\n退款类型：${rowData?.refundTypeDesc}`
                        }
                      }

                      console.log(tagValue,tagBool)


                      const params = {
                        column,
                        value: cellValue,
                        columnId: fieldId,
                        rowData: rowData,
                      };

                      function handleTdClick() {
                        emit('tdClick', params);
                      }

                      if (column?.render) {
                        return (
                          <td
                            className="td"
                            onClick={handleTdClick}>
                            {column.render(params)}
                          </td>
                        );
                      }
                      return (
                        <td
                          style={{textAlign: startBool ? 'left' : endBool ? 'right' : 'center'}}
                          className="td"
                          onClick={handleTdClick}>
                          <div className="header-title">
                            {tagBool && <span className="th-tag" style={{backgroundColor: tagValue}}></span>}
                            {isPupBool && <span onClick={() => {
                              showConfirmDialog({
                                title: `${titleValue}详情`, 
                                message: isAddDes && isRefundDes ? `${cellValue}\n${isAddDes}\n${isRefundDes}` : isAddDes ? `${cellValue}\n${isAddDes}` : `${cellValue}\n${isRefundDes}`,
                                confirmButtonText: '我知道了', 
                                showCancelButton: false
                              })}} className="th-link">{cellValue}</span>}
                            {!isPupBool && <span className="th-title">{cellValue}</span>}
                            {desValue && <span className="title">{desValue}</span>}
                          </div>
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
          {dataState.value.length > MAX_ROWS && (
            <div className={"show-more-btn" + (showAll.value ? ' show-more-btn--collapse' : '')} onClick={toggleShowAll}>
              <span>{showAll.value ? '收起' : '查看更多'}</span>
              <svg
                style={{
                  transform: showAll.value ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s',
                  marginLeft: '4px',
                  verticalAlign: 'middle',
                  width: '16px',
                  height: '16px',
                }}
                viewBox="0 0 1024 1024"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
              >
                <path d="M512 672c-8.2 0-16.4-3.1-22.6-9.4L201.4 374.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L512 594.7l265.3-265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L534.6 662.6c-6.2 6.3-14.4 9.4-22.6 9.4z" />
              </svg>
            </div>
          )}
        </div>
      );
    },
  });
</script>

<style scoped lang="scss">
  $borderColor: #e5e6eb;

  .sort-table {
    width: 100%;
    font-size: 12px;
    color: #1d2129;
    // border: 1px solid $borderColor;
    border-collapse: collapse;
    table-layout: fixed;
    .thead {
      color: #86909c;
      background: #fff;
      
      .header-title {
        display: inline-block;
        vertical-align: middle;
        text-align: center;
      }
      .th-title {
        display: block;
        font-weight: 600;
      }
      .th {
        font-weight: 400;
        height: 32px;
        text-align: center;
        padding: 6px 0 6px 3%;
        box-sizing: border-box;
        white-space: nowrap;
      }
    }
    .tbody {
      .tr {
        // border-bottom: 1px solid $borderColor;
      }
      .td {
        min-height: 40px;
        padding: 10px 0 10px 3%;
        box-sizing: border-box;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .header-title {
        display: inline-block;
        vertical-align: middle;
      }
      .th-title {
        display: inline-block;
      }
      .title {
        display: inline-block;
      }

      .th-tag {
        display: inline-block;
        height: 12px;
        width: 12px;
        border-radius: 50%;
        margin-right: 4px;
      }
    }
    .th-sortable {
      .title {
        display: inline-block;
      }
    }

    .th-link {
      cursor: pointer;
      border-bottom: 1px dashed #409eff;
    }
  }

  .show-more-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2c3e50;
    font-size: 12px;
    cursor: pointer;
    margin: 8px 0;
    user-select: none;
    transition: color 0.2s;

    &:hover {
      color: #2c3e50;
    }
    &.show-more-btn--collapse {
      color: #2c3e50;
      &:hover {
        color: #2c3e50;
      }
    }
  }
</style>
